import {
  ROLE_LIST_GET_LIST,
  ROLE_LIST_GET_LIST_SUCCESS,
  ROLE_LIST_GET_LIST_ERROR,
  // ROLE_LIST_GET_LIST_WITH_FILTER,
  PROPERTY_LIST_GET_LIST,
  PROPERTY_LIST_GET_LIST_SUCCESS,
  PROPERTY_LIST_GET_LIST_ERROR,
  // PROPERTY_LIST_GET_LIST_WITH_FILTER,
  USER_LIST_GET_LIST,
  USER_LIST_GET_LIST_SUCCESS,
  USER_LIST_GET_LIST_ERROR,
  // USER_LIST_GET_LIST_WITH_FILTER,
  AGENT_LIST_GET_LIST,
  AGENT_LIST_GET_LIST_SUCCESS,
  AGENT_LIST_GET_LIST_ERROR,
  ROLE_PERMISSION,
  CHECK_MYMA_SUPER_ADMIN,
  CHECK_USER_SUPER_ADMIN,
} from '../actions';
const INIT_STATE = {
  users: null,
  roles: null,
  properties: null,
  agentsList: null,
  loading: false,
  loading1: false,
  loading2: false,
  rolePermission: null,
  isMymaSuperAdmin: false,
  isSuperAdmin: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ROLE_LIST_GET_LIST:
      return { ...state, loading1: false };

    case ROLE_LIST_GET_LIST_SUCCESS:
      return { ...state, loading1: true, roles: action.payload.roles };

    case ROLE_LIST_GET_LIST_ERROR:
      return { ...state, loading1: true, error: action.payload };

    case CHECK_MYMA_SUPER_ADMIN:
      return { ...state, loading1: true, isMymaSuperAdmin: action.payload };

    case CHECK_USER_SUPER_ADMIN:
      return { ...state, loading1: true, isSuperAdmin: action.payload };

    // case ROLE_LIST_GET_LIST:
    // 	return { ...state, loading: false };

    // case ROLE_LIST_GET_LIST_SUCCESS:
    // 	return { ...state, loading: true, roles: action.payload.roles };

    // case ROLE_LIST_GET_LIST_ERROR:
    // 	return { ...state, loading: true, error: action.payload };

    case PROPERTY_LIST_GET_LIST:
      return { ...state, loading2: false };

    case PROPERTY_LIST_GET_LIST_SUCCESS:
      return {
        ...state,
        loading2: true,
        properties: action.payload.properties,
      };

    case PROPERTY_LIST_GET_LIST_ERROR:
      return { ...state, loading2: true, error: action.payload };

    case AGENT_LIST_GET_LIST:
      return { ...state };
    case AGENT_LIST_GET_LIST_SUCCESS:
      return { ...state, agentsList: action.payload };
    case AGENT_LIST_GET_LIST_ERROR:
      return { ...state, error: action.error };

    case USER_LIST_GET_LIST:
      return { ...state, loading: false };

    case USER_LIST_GET_LIST_SUCCESS:
      return { ...state, loading: true, users: action.payload.users };

    case USER_LIST_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };
    case ROLE_PERMISSION:
      return { ...state, rolePermission: action.payload };
    default:
      return { ...state };
  }
};
